export class VideoLibrary {
    totalCount: number;
    videoList: VideoInfoRaw[];
    countExceeded: boolean;
    minutesExceeded:boolean
}

export class VideoLibraryExt extends VideoLibrary {
    error?: string;
    isAllSelected?: boolean;
    allowUpload?: boolean;
}

export class VideoInfoRaw {  
  id?: number;
  attributes: VideoInfoExt;
  statusCode: number;
}

export class VideoInfo {
  publishedAt?: string;
  createdAt?: string;
  updatedAt?: string;
  description?: string;
  title?: string;
  language?: string;
  difficultyLevel?: string;
  baseType?: string;
  feedFM?: boolean;
  publishedToFacility?: boolean;
  lastPublishedOn?: string;
  muxAsset?: MuxAssetRaw;
  facilityId: string;
  authorName?: string;
  authorID?: string;
  unitSystem?: string;
  muxIdFacIdUID?: string;
  status?: string;
  aquamanFBKey?: string;
  workoutThumbnail?: ImageInfoRaw;
  instructor?: { data: InstructorRaw };
  workoutThumbnailIndex?: string;
}

export class VideoInfoExt extends VideoInfo {
  videoThumbnails?: ImageInfoExt[];
  uploadProgress?: number;
  validationErrors?: string[];
  file?: File;
  isSelected?: boolean;
  muxUpChunkInstance?: any;  
  baseTypeDisplayName?: string;
  avatar?: ImageInfoExt;
  displayWorkoutImage?: ImageInfoExt;
  duration?: number;
}

export class ImageInfoRaw {
  data: {
    id?: number;
    attributes: ImageInfoExt;
  };

  constructor() {
    this.data = {
      attributes: new ImageInfoExt()
    }
  }
}

export class ImageInfo {
  url?: string;
  width?: string;
  height?: string;
  size?: number;
  hash?: string;
  name?: string;
  alternativeText?: string;
  caption?: string;
  path?: string;
  ext?: string;
  mime?: string;
  createdAt?: string;
  updatedAt?: string;
  previewUrl?: string;
  provider?: string;
  provider_metadata?: string;
  formats?: ImageFormats;
  related?: ImageRelatedInfoRaw;
}

export class ImageRelatedInfoRaw {
  data: [{
    id?: number;
    attributes: VideoInfo | Customization;
  }];
}

export class ImageInfoExt extends ImageInfo {
  base64?: string;
  isSelected?: boolean;
  index?: string;
  isChanged?: boolean;
}

export class ImageFormats {
  thumbnail?: ImageInfo;
  small?: ImageInfo;
  medium?: ImageInfo;
  large?: ImageInfo;
}

export class MuxAssetRaw {
  data: {
    id?: any;
    attributes: MuxAsset;
  };

  constructor() {
    this.data = {
      attributes: new MuxAsset()
    }
  }
}

export class MuxAsset {
  title?: string;
  upload_id?: string;
  asset_id?: string;
  playback_id?: string;
  error_message?: string;
  isReady?: boolean;
  createdAt?: string;
  updatedAt?: string;
  duration?: number;
  aspectRatio?: string;
  metadata?: {
    data: {
      id?: number;
      attributes: MuxAssetMetadata;
    }
  }
}

export class MuxAssetMetadata {
  initUploadFacility?: string;
  linkedToVideoData?: boolean;
  maxStoredResolution?: string;
  maxStoredFrameRate?: number;
  maxWidth?: number;
  maxHeight?: number;
  createdAt?: string;
  updatedAt?: string;
  publishedAt?: string;
  defaultThumbnail?: ImageInfoRaw;
  muxAsset?: MuxAssetRaw;
}

export class InstructorRaw {
  id?: number;
  attributes: Instructor;
}

export class Instructor {
  name?: string;
  uuid?: string;
  createdAt?: string;
  updatedAt?: string;
  publishedAt?: string;
  avatar?: ImageInfoRaw;
  facilities?: [{id: number, facilityId: string}]
}

export class Customization {
  id: number;
  categoryName: string;
  facilityId: string;
  createdAt: string;
  updatedAt: string;
  categoryNameUpdatedBy: string;
  categoryNameUpdatedOn: string;
  bannerUpdatedBy: string;
  logoUpdatedBy: string;
  bannerUpdatedOn: string;
  logoUpdatedOn: string;
  bannerSE4UpdatedBy: string;
  bannerSE4UpdatedOn: string;
  bannerHeadline: string;
  bannerHeadlineUpdatedBy: string;
  bannerHeadlineUpdatedOn: string;
  bannerDescription: string;
  bannerDescriptionUpdatedBy: string;
  bannerDescriptionUpdatedOn: string;
  bannerSE4Name?: string;
  bannerName?: string;
  bannerSE4: ImageInfoRaw;
  logo: ImageInfoRaw;
  banner: ImageInfoRaw;
  logoName: string
}

export enum ImageSize {
  THUMBNAIL = 0,
  SMALL,
  MEDIUM,
  LARGE
}
